import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FuseNavigationItem } from '@fuse/types';
import { AZIONI, CostantiStorage, TipoUtente } from 'app/main/utils/costanti';
import { SessioneUtenteQuery } from 'app/main/utils/state';
import { SessioneUtente } from 'app/main/utils/state/utente-sessione.model';
import { Utils } from 'app/main/utils/utils';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseNavigationService } from './navigation.service';
import { CommonService } from 'app/main/utils/service/common.service';
import { FuseNavVerticalCollapsableComponent } from './vertical/collapsable/collapsable.component';
import { FuseNavVerticalGroupComponent } from './vertical/group/group.component';
import { FuseNavVerticalItemComponent } from './vertical/item/item.component';

@Component({
  standalone: true,
  imports: [FuseNavVerticalGroupComponent, FuseNavVerticalCollapsableComponent, FuseNavVerticalItemComponent],
  selector: 'fuse-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FuseNavigationComponent implements OnInit {
  @Input()
  layout = 'vertical';

  @Input()
  navigation: any;

  private _unsubscribeAll: Subject<any>;

  utente;

  constructor(
    private _fuseNavigationService: FuseNavigationService,
    private sessioneUtenteQuery: SessioneUtenteQuery,
    private commonService: CommonService
  ) {
    if (window.location.href.indexOf('login') >= 0) {
      const urlPreLogout = localStorage.getItem(CostantiStorage.URLPRELOGOUT);
      const versionApp = localStorage.getItem(CostantiStorage.VERSION);
      if (versionApp) {
        localStorage.setItem(CostantiStorage.VERSION, versionApp);
      }
      if (urlPreLogout) {
        localStorage.setItem(CostantiStorage.URLPRELOGOUT, urlPreLogout);
      }
    }
    this.utente = sessioneUtenteQuery.loggedUser();
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.navigation = this.navigation || this._fuseNavigationService.getCurrentNavigation();

    this._fuseNavigationService.onNavigationChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.navigation = this._fuseNavigationService.getCurrentNavigation();
      const menu = this._fuseNavigationService.getMenu();
      // tslint:disable-next-line:forin
      for (const key in menu) {
        const index = this.navigation.findIndex(item => item.id === key);
        if (index >= 0) {
          this.navigation[index].visibile = menu[key] === 1;
        }
        this.navigation
          .filter(item => item.filtraFigli)
          .forEach(item => this.applicaMenuAiFigli(item, key, menu[key] === 1));
      }
    });
  }

  readonly isVisibile = (item: FuseNavigationItem): boolean => this.checkVisibile(item);

  readonly tracker = (item: FuseNavigationItem): void => {
    this.stats(item);
  };

  private applicaMenuAiFigli(parent: FuseNavigationItem, key: string, visibile: boolean): void {
    parent.children.forEach(child => {
      if (child.id === key) {
        child.visibile = visibile;
      }
      if (child.filtraFigli) {
        this.applicaMenuAiFigli(child, key, visibile);
      }
    });
  }
  get loggedUser(): SessioneUtente {
    return this.sessioneUtenteQuery.loggedUser();
  }
  checkVisibile(item: FuseNavigationItem) {
    if (item.filtraFigli) {
      return item.children.some(child => this.checkVisibile(child));
    }
    const loggedUser = this.utente;
    const shouldCheckNonSoci = this.sessioneUtenteQuery.loggedUser()
      ? this.sessioneUtenteQuery.loggedUser().tipo_utente === TipoUtente.NonSocio
      : true;
    const shouldCheckFondazione = this.sessioneUtenteQuery.loggedUser()
      ? this.sessioneUtenteQuery.loggedUser().tipo_utente === TipoUtente.Fondazione
      : true;
    const shouldCheckTerzo = this.shouldCheckVisibilePerTerzi();
    const shouldCheckVisibileFondazione = this.shouldCheckVisibilePerFondazione();
    // ? Nuova aggiunta
    const shouldCheckSezione = this.sessioneUtenteQuery.loggedUser()
      ? [TipoUtente.Nazionale, TipoUtente.Provinciale, TipoUtente.Regionale].includes(
          this.sessioneUtenteQuery.loggedUser().tipo_utente
        )
      : true;
    if (Utils.isApp() && item.nascostoInApp) {
      return false;
    }

    let isVisible = !!item.visibile;
    if (shouldCheckNonSoci) {
      isVisible = isVisible && item.visibilePerNonSoci;
    }
    if (shouldCheckFondazione) {
      isVisible = isVisible && item.visibilePerNonSoci;
    }
    if (item.visibilePerSocioSezioneRegionale && loggedUser) {
      if (item.visibilePerSocioSezioneRegionale === loggedUser.id_sezione_regionale) {
        isVisible = true;
      } else {
        isVisible = false;
      }
    }
    if (shouldCheckSezione) {
      isVisible = isVisible && item.visibilePerSezioni != false;
    }

    if (shouldCheckTerzo) {
      isVisible = item.visibilePerTerzi;
      return isVisible;
    }
    if (shouldCheckVisibileFondazione) {
      isVisible = item.visibilePerFondazione;
      return isVisible;
    }
    return isVisible;
  }

  shouldCheckVisibilePerTerzi() {
    //agenas
    const loggedId = this.sessioneUtenteQuery.loggedUser() ? this.sessioneUtenteQuery.loggedUser().id : -1;
    const isLoggedTerzo = new Set([1000067173, 1000067174]).has(<number>loggedId);
    return isLoggedTerzo;
  }
  shouldCheckVisibilePerFondazione() {
    //altri
    const loggedId = this.sessioneUtenteQuery.loggedUser() ? this.sessioneUtenteQuery.loggedUser().id : -1;
    //rimosso 950000004--> rsgintegrato
    const isLoggedAltri = new Set([950000000, 950000001, 950000002, 950000003, 950000004, 950000006]).has(
      <number>loggedId
    );
    return isLoggedAltri;
  }
  async stats(item: FuseNavigationItem) {
    try {
      if (item.trackerIndex) {
        await this.commonService.stats({
          azione: AZIONI.Navigazione,
          navigazione: item.trackerIndex
        });
      }
    } catch (error) {}
  }
}
